import { ArrowForwardIos } from '@mui/icons-material';
import { Divider, ListItemButton, Paper, Stack, Typography } from '@mui/material';
import { formBySubmissionRoute } from '@uplift/constants';
import { useTimezone } from '@uplift/contexts';
import { useRequestAdministeredSubmissionMutation } from '@uplift/queries';
import { CalendarDateService } from '@uplift/services';
import { ProgressIcon, useAlert } from '@uplift/ui-v2';
import React from 'react';
import { useHistory } from 'react-router';
import { AssessmentOption, useAssessmentOptions } from './hooks';


const AssessmentItem: React.VFC<{ option: AssessmentOption; patientId: string }> = (props) => {
  const timezone = useTimezone();
  const history = useHistory();
  const alert = useAlert();
  const requestAdministeredSubmissionMutation = useRequestAdministeredSubmissionMutation();
  const [ isLoading, setIsLoading ] = React.useState(false);

  return (
    <Stack
      disabled={isLoading}
      component={ListItemButton}
      direction="row"
      alignItems="center"
      p={3}
      sx={{ height: '100px' }}
      onClick={async () => {
        try {
          setIsLoading(true);
          const response = await requestAdministeredSubmissionMutation.mutateAsync({
            patientId: props.patientId,
            formId: props.option.id,
          });

          setIsLoading(false);
          history.push(formBySubmissionRoute.createLink({ submissionId: response.data.submissionId }));
        } catch {
          alert.error('Something went wrong. Please try again later');
        } finally {
          setIsLoading(false);
        }
      }}
    >
      <Stack flex={1}>
        <Typography fontWeight={500}>{props.option.name}</Typography>
      </Stack>
      <Stack direction="row" gap={1} alignItems="center">
        {props.option.lastCompletedAt ? (
          <Typography component="span" variant="body2">Last completed {CalendarDateService.date(props.option.lastCompletedAt).tz(timezone).format('MMM D')}</Typography>
        ) : (
          <Typography component="span" variant="body2">No submissions</Typography>
        )}
        {isLoading ? <ProgressIcon size={12} /> : <ArrowForwardIos sx={{ fontSize: '12px' }} />}
      </Stack>
    </Stack>
  );
};


export const AdministerTab: React.VFC<{ patientId: string }> = (props) => {
  const options = useAssessmentOptions(props.patientId);

  return (
    <Stack gap={2} sx={{ p: 2 }}>
      <Typography variant="body2">
        Answers are recorded as clinician-administered.
      </Typography>

      <Paper variant="outlined">
        {options.map((option, index) => (
          <React.Fragment key={option.id}>
            {index !== 0 && <Divider />}
            <AssessmentItem patientId={props.patientId} option={option} />
          </React.Fragment>
        ))}
      </Paper>
    </Stack>
  );
};
